import { render, staticRenderFns } from "./SalariePrintSynteticExcel.vue?vue&type=template&id=405df7e2&scoped=true"
import script from "./SalariePrintSynteticExcel.vue?vue&type=script&lang=js"
export * from "./SalariePrintSynteticExcel.vue?vue&type=script&lang=js"
import style0 from "./SalariePrintSynteticExcel.vue?vue&type=style&index=0&id=405df7e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405df7e2",
  null
  
)

export default component.exports